__turbopack_context__.v({
  "transitionSize": "Button-module__4y52ua__transitionSize",
});
